import { useTranslation } from 'react-i18next';
import Layout from '../../Layout/Layout';
import CreateBroadcast from './components/CreateBroadcast';
import StreamsDataTable from './components/StreamsDataTable';

import { useSelector, useDispatch } from 'react-redux';
import { toggleDialog } from '../../../redux/Slices/Global/globalSlice';
import { useTitle } from '../../../config/global';
import { useMemo } from 'react';
import { useDataTableContext } from '../../Contexts/DataTableContext';
import FeatureLocked from '../../SharedComponents/FeatureLocked';

function BroadcastCard() {
    const { t } = useTranslation();
    const { openDialog, isLoading } = useSelector((state) => state.global);
    const dispatch = useDispatch()
    const { getDataTable } = useDataTableContext();
    useTitle("Broadcast");

    const subNavbarContent = useMemo(() => {
        return (
            <div className='flex justify-end w-100'>
                <button type="reset" className="btn btn-primary "
                    disabled={isLoading}
                    onClick={() => dispatch(toggleDialog("createBroadcastDialog"))} >
                    {t('broadcast.new_broadcast')}
                </button>
            </div>
        );
    }, [isLoading]);

    const subNavbarProps = useMemo(() => {
        return {
            icon: <i className="fas fa-broadcast-tower fs-3 text-secondary "></i> || " ",
        };
    }, []);

    if (getDataTable.error?.response?.status === 402) {
        return (
            <Layout>
                <FeatureLocked feature="live_meeting_access" message={getDataTable.error.response.data?.message} />
            </Layout>
        );
    }

    return (
        <Layout subNavbarProps={subNavbarProps} subNavbarContent={subNavbarContent}>
            <div className="card h-100">
                <div className="card-body">
                    <div className="d-flex flex-column m-2">
                        <StreamsDataTable />
                    </div>
                </div>
            </div>
            {openDialog.createBroadcastDialog && <CreateBroadcast />}
        </Layout>
    )
}

export default BroadcastCard